import api from "./api";

export const dashboardService = {
    async stats() {
        const { data } = await api.get("/dashboard/stats");
        return data;
    },
    async recent() {
        const { data } = await api.get("/dashboard/recent");
        return data;
    },
    async assetsByCategory() {
        const { data } = await api.get("/dashboard/charts/assets-by-category");
        return data;
    },
    async customersByCity() {
        const { data } = await api.get("/dashboard/charts/customers-by-city");
        return data;
    },
    async workOrdersByStatus() {
        const { data } = await api.get("/dashboard/charts/work-orders-by-status");
        return data;
    },
};
